export function initSliderHp() {
    for (const section of document.querySelectorAll('.slider-hp:not([data-slider-hp-initialized])')) {
        section.dataset.sliderHpInitialized = ''

        const gradient = section.dataset.gradient
        if (gradient) {
            section.style.setProperty('--slider-hp-gradient', gradient)
        }
    }
}
